"use strict";
/**
 * Cognito Forms WordPress Plugin
 */
Object.defineProperty(exports, "__esModule", { value: true });
var blocks_1 = require("@wordpress/blocks");
/**
 * Internal dependencies
 */
var edit_1 = require("./edit");
var save_1 = require("./save");
/**
 * Stylesheets
 */
require("./styles/editor.scss");
require("./styles/style.scss");
var cogicon_svg_1 = require("@/../cogicon.svg");
(0, blocks_1.registerBlockType)('cognito-forms/cognito-embed', {
    title: 'Cognito Forms',
    icon: cogicon_svg_1.ReactComponent,
    description: 'Easily build powerful forms.',
    category: 'embed',
    supports: {
        // Removes support for an HTML mode.
        html: false,
    },
    attributes: {
        orgId: {
            type: 'string',
        },
        formId: {
            type: 'string',
        },
        seamlessEmbedCode: {
            type: 'string',
        },
        iframeEmbedCode: {
            type: 'string',
        },
        ampEmbedCode: {
            type: 'string',
        },
        embedMode: {
            type: 'number',
        },
    },
    edit: edit_1.default,
    save: save_1.default,
});
